'use client';

import dynamic from 'next/dynamic';
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { TypePageIndustry } from '@fm-nx/contentful-types';

const Nav = dynamic(() => import('../../components/nav'));
const PageIntroLevel2Display = dynamic(
    () => import('@fm-nx/ui').then((mod) => ({ default: mod.PageIntroLevel2Display })),
    {
        ssr: false,
    }
);
const BlockRenderer = dynamic(() => import('@fm-nx/ui').then((mod) => ({ default: mod.BlockRenderer })));

interface IndustryDetailProps {
    page: TypePageIndustry<'WITHOUT_UNRESOLVABLE_LINKS'>;
    preview: boolean;
}

export default function IndustryDetail({ page, preview }: IndustryDetailProps) {
    const updatedPage = useContentfulLiveUpdates(page);
    const { sections = [] } = updatedPage.fields;

    return (
        <div>
            <Nav variant="dark" preview={preview} />
            <PageIntroLevel2Display
                overline="Industries"
                title={updatedPage?.fields.title || ''}
                headerText={updatedPage?.fields.heroHeading || updatedPage?.fields.title || ''}
                headerParagraph={updatedPage?.fields.summary}
                button={{
                    sys: { id: `page-intro-text-${updatedPage?.sys.id}` },
                    __typename: 'Button',
                    buttonText: 'Start a Conversation',
                    linkPath: '#contact',
                }}
                backgroundColor="powder"
            />
            <BlockRenderer block={sections} suppressFirstBlockTopMargin />
        </div>
    );
}
